// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies-reactive';

import modules from './modules'

import CartApi from "@/services/cart-api";



Vue.use(Vuex);
Vue.use(VueCookies);

// Define constants
const CART_ID_COOKIE_NAME = 'uscid';

const store =  new Vuex.Store({

  modules,

  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',

  state: {

    //CART
    cart: null,
    isLoadingCart: false,

  },

  mutations: {

    ///////////////
    // CART MUTATIONS

    setCart(state, cart) {
        if (cart && cart.cartId) {
          state.cart = cart;
          writeCookie(CART_ID_COOKIE_NAME, cart.cartId);
        } else {
          state.cart = null; 
          clearCookie(CART_ID_COOKIE_NAME)
        }
    },

    setLoadingCart(state, isLoading) {
      state.isLoadingCart = isLoading;
    },


  },
  actions: {
    //////////////////////
    // CART ACTIONS

    fetchCart({commit}) {      
      let newId = Vue.$cookies.get(CART_ID_COOKIE_NAME)

      if (!newId) {
        commit('setCart', null );
        return;
      }

      commit('setLoadingCart', true);
      CartApi.get(newId).then(
        (response)=> {
          if (response && response.status == 200 && response.data) {
            const cart = response.data;
            commit('setCart', cart );
          }
        }
      ).finally(() => {
        commit('setLoadingCart', false);
      });
    }, 

addToCart({commit}, addToCartRequestList) {
  return new Promise((resolve, reject) => {
      const cartId = this.state.cart ? this.state.cart.cartId : readCookie(CART_ID_COOKIE_NAME) ;
            CartApi.add(cartId,  addToCartRequestList).then(
              (response)=> {
        if (response && response.status == 200 && response.data) {
          const cart = response.data;
          commit('setCart', cart)
          resolve(cart);
        } else {
                  reject();
        }
              }
            ) .catch((error) => {
              reject(error);
            });
  });
},

    setDeliveryModeToCart({commit}, deliveryModeId) {
      return new Promise((resolve, reject) => {
            if (!deliveryModeId) {
              return;
            }
            CartApi.deliveryModeToCart(this.state.cart ? this.state.cart.cartId : null, deliveryModeId).then(
              (response)=> {
                if (response && response.status == 200 && response.data) {
                    const cart = response.data;
                    commit('setCart', cart)  
                    resolve(cart);
                } else {
                  reject();
                }
              }
            ) .catch((error) => {
              reject(error);
            });
        });
    },

    removeFromCart({commit}, variantId) {
      return new Promise((resolve, reject) => {
            if (!variantId) {
              return;
            }
            CartApi.remove(this.state.cart ? this.state.cart.cartId : null, variantId).then(
              (response)=> {
                if (response && response.status == 200) {
                    const cart = response.data;
                    commit('setCart', cart)  
                    resolve(cart);
                } else {
                  reject();
                }
              }
            ) .catch((error) => {
              reject(error);
            });
        });
    },

  },
});


function writeCookie(key, value) {
  var currentDomain = window.location.hostname;
  var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;
  
  const expiryDays = 365;
  var expiryDate = new Date(Date.now() + expiryDays * 1000 * 60 * 60 * 24);
  
  document.cookie = key + "=" + value + "; " +
                     "expires=" + expiryDate.toUTCString() + "; " +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";
}

function readCookie(key) {
  const name = key + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

function clearCookie(key) {
  var currentDomain = window.location.hostname;
  document.cookie = key + '=; Max-Age=0; domain=' + currentDomain + '; path=/';
}

export default store


